import { MoreVert } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";

interface IKeydriveMenu<T> {
    options: T[];
}

export interface IKeydriveMenuTable {
    text: string;
    icon: React.ReactNode;
    onClick: () => void;
}

function KeydriveMenu<T extends IKeydriveMenuTable>({
    options
}: IKeydriveMenu<T>) {

const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((option) => (
          <MenuItem onClick={option.onClick} sx={{ display: "flex", alignItems: "center" }}>
            <Box mr="10px">
                {option.icon}
            </Box>
            {option.text}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default KeydriveMenu;